var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStationeryAndBooks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Book-Library-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Book Library 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 18a0.5 0.5 0 0 0 -0.5 -0.5H0.5a0.5 0.5 0 0 0 -0.5 0.5v1a2.5 2.5 0 0 0 2.5 2.5V23a1 1 0 0 0 2 0v-1.25a0.25 0.25 0 0 1 0.25 -0.25h14.5a0.25 0.25 0 0 1 0.25 0.25V23a1 1 0 0 0 2 0v-1.5A2.5 2.5 0 0 0 24 19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 16.5h4a0.5 0.5 0 0 0 0.5 -0.5V1a1 1 0 0 0 -1 -1h-3a1 1 0 0 0 -1 1v15a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.5h4a0.5 0.5 0 0 0 0.5 -0.5V1a1 1 0 0 0 -1 -1h-3a1 1 0 0 0 -1 1v15a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.28 16.49 3.84 -0.72a0.49 0.49 0 0 0 0.39 -0.57L19.82 0.8a1 1 0 0 0 -1.14 -0.8L15.8 0.55a1 1 0 0 0 -0.8 1.14l2.71 14.41a0.48 0.48 0 0 0 0.57 0.39Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStationeryAndBooks);
export default ForwardRef;